module.exports = __webpack_public_path__ + "img/mob2.a2606207.png";